import { ArrowLeft, BankIcon, LogoIconSmall } from '@/shared/assets';
import {
  DashboardDialogProps,
  ModalCard,
  ModalCardItemWithIcon,
} from '@/shared/ui';
import { Soon } from '@/shared/ui/components/soon';

import { MoneyFlowType } from '../../../../model/types';
import { useSendMoney } from '../../../../model/useSendMoney';

const AddRecipient: React.FC<{
  setStep: (step: MoneyFlowType) => void;
}> = ({ setStep }) => {
  const resetData = useSendMoney((state) => state.resetData);
  return (
    <div className="mt-1 flex flex-col gap-y-1">
      <ModalCard className="px-1 py-1 gap-y-0">
        <ModalCardItemWithIcon
          title="Find on FCB"
          description="By e-mail or mobile number"
          descClassName="md:max-w-[130px]"
          icon={<LogoIconSmall className="h-6 w-6" />}
          as="button"
          className="text-left hover:bg-hover-base-300-hover px-4 py-5 rounded-[24px]"
          noWrapper
          rightContent={<Soon text="Faster" className="px-3 bg-base-100" size='xs' />}
          onClick={() => {
            resetData();
            setStep('find-client');
          }}
        />
        <ModalCardItemWithIcon
          title="Bank details"
          description="Enter name and other details"
          icon={<BankIcon className="h-5 w-5" />}
          as="button"
          noWrapper
          className="text-left hover:bg-hover-base-300-hover px-4 py-5 rounded-[24px]"
          onClick={() => {
            setStep('choose-flow');
          }}
        />
      </ModalCard>
    </div>
  );
};

interface AddRecipientProps {
  setStep: (step: MoneyFlowType) => void;
  onBack: () => void;
  isFirst: boolean;
}

export const addRecipientProps = ({
  setStep,
  onBack,
  isFirst,
}: AddRecipientProps): DashboardDialogProps => {
  return {
    title: 'Add a recipient',
    content: <AddRecipient setStep={setStep} />,
    animationProps: {
      id: 'choose',
      isFirst: isFirst,
    },
    modalProps: {
      classNames: {
        title: 'max-w-[235px] px-5',
      },
    },
    disableOutsideClick: !isFirst,
    serviceButton: !isFirst
      ? {
        icon: <ArrowLeft className="min-h-6 min-w-6" />,
        onClick: () => {
          onBack();
        },
      }
      : undefined,
    hideCloseButton: !isFirst,
  };
};
